import Vue from 'vue'
import App from './App.vue'
import store from './store';
import { parseTime, resetForm, addDateRange, addDate, selectDictLabel, selectDictLabels, handleTree, tableSorter , selectDictLabelsWelfare } from '@/utils/ruoyi'
// 应用ant-design-vue
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd)
// 引用swiper
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.css'
Vue.use(vueSwiper)
//引入路由配置
import router from "./router/index";
// 引入动画库
import animate from "animate.css";
// 滑块验证
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

import Print from 'vue-print-nb'
Vue.use(Print)

import $ from 'jquery'
Vue.prototype.$ = $

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {  MessageBox, } from 'element-ui';
Vue.component(MessageBox.name, MessageBox,);
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.confirm;
Vue.use(ElementUI)

// 图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});



// 地图
// import BaiduMap from "vue-baidu-map";
// Vue.use(BaiduMap, {
  // ak: "PVYIYNlPw1uzSIlHa1Oc0EVe10dtxjby&services=&t=20210305180032",
  //  ak:"XhvlqQAtfLaXV6KpjwVSAguG0pN31VAx&services=&t=20250925",
  //  ak:"hcGerNKvFhveefvJR71XCjKv70ivdXVv&services=&t=20251212",
// });
// 重置样式
import "./assets/css/reset.css"

var EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus;
    },
  },
});
// 使用eventBus
Vue.prototype.event = new Vue(); //eventBus

// 全局方法
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.addDate = addDate
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.selectDictLabelsWelfare = selectDictLabelsWelfare
Vue.prototype.handleTree = handleTree
Vue.prototype.tableSorter = tableSorter
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
